import { SxProps, Theme } from '@mui/system';

const legendHeight = 345.5;

const styles = {
  container: {
    marginTop: '16px',
    display: 'flex',
    backgroundColor: 'secondary',
    flexDirection: 'column',
  },
  list: {
    overflowY: 'auto',
    overFlowX: 'hidden',
  },
  dynamicHeight: (height: number) =>
    ({
      height: (height * 3) / 4 - legendHeight,
    }),
  title: {
    margin: '16px',
    fontWeight: 600,
  },
  segment: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  segmentButtons: {
    width: '100% !important',
    fontSize: 12,
    borderRadius: 0,
  },
  text: {
    position: 'relative',
    minWidth: 110,
    maxWidth: 110,
  },
  active: {
    fontWeight: 500,
    borderBottom: '1px solid',
  },
  inActive: {
    color: 'grey.500',
    fontSize: 12,
  },
  alertRedDot: {
    height: 7,
    width: 7,
    borderRadius: 3.5,
    backgroundColor: 'red',
    position: 'absolute',
    top: 0,
    right: 8,
  },
  activeText: {
    fontWeight: '500',
  },
  badge: {
    '& .MuiBadge-badge': {
      right: 10,
      top: -4,
      height: 15,
      minWidth: 15,
      fontSize: 10,
    },
  },
} satisfies Record<
  string,
  SxProps<Theme> | ((height: number) => SxProps<Theme>)
>;

export default styles;
